import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

import { IContext } from '../../context/models/context';
import { CashBalancesModel } from '../models/cash-balances.model';
import { SubLedgerModel } from '../models/sub-ledger.model';
import { CashBalanceConfiguration } from '../models/cash-balance-configuration.model';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { SaveCashBalanceWidgetConfigurationRequest } from '../models/cash-balance-configuration.model';

@Injectable()
export class CashBalanceHttpService {

  constructor(private http: HttpClient, private urlBuilderService: UrlBuilderService) { }

  getCashBalances(context: IContext): Observable<Array<CashBalancesModel>> {
    const arrearsUrl = this.urlBuilderService.getUrl('cashbalances');
    return this.http
      .post<Array<CashBalancesModel>>(arrearsUrl, context).pipe(
        map(arrears => arrears || undefined)
      );
  }

  getSubLedgers(): Observable<Array<SubLedgerModel>> {
    const subLedgersUrl = this.urlBuilderService.getUrl('subledgers');
    return this.http
      .get<Array<SubLedgerModel>>(subLedgersUrl).pipe(
        map(subLegders => subLegders || undefined)
      );
  }

  getAllCashBalanceConfigurations(): Observable<Array<CashBalanceConfiguration>> {
    const url = this.urlBuilderService.getUrl('cashbalances/configs');
    return this.http
      .get<Array<CashBalanceConfiguration>>(url).pipe(
        map(configurations => configurations || undefined)
      );
  }

  getCashBalanceConfiguration(widgetConfigurationId: number): Observable<CashBalanceConfiguration> {
    const url = this.urlBuilderService.getUrl(`cashbalances/${widgetConfigurationId}/config`);
    return this.http
      .get<CashBalanceConfiguration>(url).pipe(
        map(configurations => configurations || undefined)
      );
  }

  saveCashBalanceConfiguration(config: SaveCashBalanceWidgetConfigurationRequest) {
    const widgetConfigsUrl = this.urlBuilderService.getUrl('cashbalances/config');
    return this.http.post(widgetConfigsUrl, config, { responseType: 'text' });
  }

  createCopyOfCashBalanceConfiguration(config: SaveCashBalanceWidgetConfigurationRequest) {
    const widgetConfigsUrl = this.urlBuilderService.getUrl('cashbalances/config/copy');
    return this.http.post(widgetConfigsUrl, config, { responseType: 'text' });
  }

}
